export const getArrayFromMap = map => Array.from(
  map,
  ([datasheetQuestionId, values]) => ({
    datasheetQuestionId,
    ...values
  })
);

export const getCustomPanelQuestions = customPanel => {
  const questions = [];

  customPanel.currentVersion.customPanelSections.forEach(section => {
    section.questions.forEach(question => {
      questions.push(question);
    });
  });

  return questions;
};

export const getResultFromMap = (map, datasheetQuestionId) => {
  const result = map.get(datasheetQuestionId)?.result;

  if (result) {
    return JSON.parse(result);
  }

  return null;
};

export const setResultObjectToMap = (map, result) => map.set(
  result.datasheetQuestionId,
  {
    currentQuestionId: result.currentQuestionId,
    customPanelId: result.customPanelId,
    customPanelVersionId: result.customPanelVersionId,
    result: result.result,
  }
);
